/**
*功能名称：数据源管理
*创 建 人：whr
*日    期：2023/06/15 10:15:17
*/

import {DbCenterBaseApiV2} from "../DbCenterBaseApiV2";
import {Methods} from "@newview/infrastructure";
export class DbBackuptaskApi extends DbCenterBaseApiV2 {
    public get ControllerName(): any {
        return 'dbBackuptask';
    }

    /**
     * 添加定时任务
     * @param params
     */
    public createTask(params) {
        return this.send(params, 'createJob', Methods.POST);
    }

    /**
     * 开始任务
     * @param params
     */
    public startTask(params) {
        return this.send(params, 'resumeJob', Methods.POST);
    }

    /**
     * 删除任务
     * @param params
     */
    public deleteTask(params) {
        return this.send(params, 'deleteJob', Methods.POST);
    }

    /**
     * 运行一次
     * @param params
     */
    public runOnceTask(params) {
        return this.send(params, 'runOnce', Methods.POST);
    }
      /**
     * 获取盘服数据
     * @param params
    */
      public  getSysFiles (params) {
        return  this.send(params, "getSysFiles", Methods.GET);
    }
 
 
}
